export var InputDialogDataHooks;
(function (InputDialogDataHooks) {
    InputDialogDataHooks["PrimaryButton"] = "InputDialog-primaryButton";
    InputDialogDataHooks["SecondaryButton"] = "InputDialog-secondaryButton";
})(InputDialogDataHooks || (InputDialogDataHooks = {}));
//# sourceMappingURL=types.js.map